import { createFeatureSelector } from '@ngrx/store';
import { SERVICING_SEATMAP_STORE_NAME, ServicingSeatmapState } from './servicing-seatmap.state';

/** Select ServicingSeatmap State */
export const selectServicingSeatmapState = createFeatureSelector<ServicingSeatmapState>(SERVICING_SEATMAP_STORE_NAME);
